<template>
    <div id="languageDropdown" class="card-header nav-item dropdown no-arrow p-0 w-100" v-if="selectedLanguage != null">
        <a class="nav-link dropdown-toggle float-right d-flex" href="#" id="languageDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <div class="dropdown-list-image mr-2">
                <img class="img-profile rounded-circle" :src="selectedLanguage.flagImagePath" :alt="selectedLanguage.longTitle">
            </div>
            <div>
                <div class="text-truncate">{{selectedLanguage.longTitle}}</div>
            </div>
        </a>
        <div id="language-dropdown-items-container" class="dropdown-list dropdown-menu dropdown-menu-right shadow animated--grow-in" aria-labelledby="languageDropdown">
            <h6 class="dropdown-header">
                {{$t('SELECT_LANGUAGE')}}
            </h6>
            <button v-for="(language, index) in languages" :key="index" class="dropdown-item d-flex align-items-center language-dropdown-item" @click="selectLanguage(language)">
                <div class="dropdown-list-image mr-2">
                    <img class="rounded-circle" :src="language.flagImagePath" :alt="language.longTitle">
                </div>
                <div :class="{ 'font-weight-bold' : language == selectedLanguage }">
                    <div class="text-truncate">{{language.longTitle}}</div>
                </div>
            </button>
        </div>
    </div>
</template>
<script>export default {
        data() {
            return {
                languages: [],
                selectedLanguage: null
            }
        },
        methods: {
            selectLanguage: function (language) {
                this.$store.dispatch('selectLanguage', language);
                this.selectedLanguage = this.$store.getters.selectedLanguage;
            },
            loadSystemLanguages: function () {
                let self = this;
                this.$store.dispatch('loadSystemLanguages')
                    .then(response => {
                        self.languages = response.data;
                        self.selectedLanguage = self.languages.filter(function (obj) {
                            return obj.title.toLowerCase() == 'en';
                        })[0];
                        this.selectLanguage(this.selectedLanguage);
                    })
                    .catch(error => {
                        console.log(error);
                    })
            },
        },
        created() {
            this.loadSystemLanguages();
        }

    }</script>
<style  lang="scss">
    #languageDropdown {
        color: #39566e;

        #language-dropdown-items-container
        {
            transform: unset !important;
            top: 50px !important;
            right: 20px !important;
            left: unset !important;
        }

         .rounded-circle
        {
            height: 30px !important;
            width: 30px !important;
            box-shadow: 0px 0px 1px #b7b9cc;
        }
    }

    .language-dropdown-item {
        .rounded-circle {
           box-shadow: 0px 0px 1px #b7b9cc;
        }
    }
</style>